import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c18798d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "head-content" }
const _hoisted_3 = { class: "part-left" }
const _hoisted_4 = { class: "main-info" }
const _hoisted_5 = { class: "other-info" }
const _hoisted_6 = { class: "part-right" }
const _hoisted_7 = { class: "main-info" }
const _hoisted_8 = { class: "other-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TerminalHead = _resolveComponent("TerminalHead")!
  const _component_BaseInfo = _resolveComponent("BaseInfo")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_OperateSystem = _resolveComponent("OperateSystem")!
  const _component_NetworkConfig = _resolveComponent("NetworkConfig")!
  const _component_SoftwareInfo = _resolveComponent("SoftwareInfo")!
  const _component_HardwareInfo = _resolveComponent("HardwareInfo")!
  const _component_ChangeLog = _resolveComponent("ChangeLog")!
  const _component_ExaminationInfo = _resolveComponent("ExaminationInfo")!
  const _component_VulnerabilityInfo = _resolveComponent("VulnerabilityInfo")!
  const _component_IssueStrategy = _resolveComponent("IssueStrategy")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "terminal-info-wrap",
    title: _ctx.drawerTitle,
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: "70%",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_TerminalHead, {
          "system-type": _ctx.baseInfo.system_type,
          "login-status": _ctx.baseInfo.login_status
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.baseInfo.computer_name), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.baseInfo.system_name), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.baseInfo.user_mark), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.baseInfo.group_name), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["system-type", "login-status"]),
        (_ctx.modelValue)
          ? (_openBlock(), _createBlock(_component_el_tabs, {
              key: 0,
              class: "tabs-wrap",
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabBasicInfo'),
                  name: "basicInfo",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseInfo, {
                      "comp-data": _ctx.baseInfo,
                      onChangeTab: _cache[0] || (_cache[0] = e => _ctx.activeTab = e),
                      onUpdate: _ctx.updateData
                    }, null, 8, ["comp-data", "onUpdate"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabOperateSystem'),
                  name: "operateSystem",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_OperateSystem, {
                      "device-id": _ctx.terminalInfo.device_id
                    }, null, 8, ["device-id"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabNetworkConfig'),
                  name: "networkConfig",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NetworkConfig, {
                      "device-id": _ctx.terminalInfo.device_id
                    }, null, 8, ["device-id"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabSoftwareInfo'),
                  name: "softwareInfo",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SoftwareInfo, {
                      "device-id": _ctx.terminalInfo.device_id
                    }, null, 8, ["device-id"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabHardwareInfo'),
                  name: "hardwareInfo",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HardwareInfo, {
                      "device-id": _ctx.terminalInfo.device_id
                    }, null, 8, ["device-id"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabChangeLog'),
                  name: "changeLog",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ChangeLog, {
                      "device-id": _ctx.terminalInfo.device_id
                    }, null, 8, ["device-id"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabExaminationInfo'),
                  name: "examinationInfo",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ExaminationInfo, {
                      "device-id": _ctx.terminalInfo.device_id
                    }, null, 8, ["device-id"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabVulnerabilityInfo'),
                  name: "vulnerabilityInfo",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VulnerabilityInfo, {
                      "terminal-info": _ctx.terminalInfo,
                      onAuthSuccess: _ctx.handleRefresh
                    }, null, 8, ["terminal-info", "onAuthSuccess"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('groupClient.terminalTabIssueStrategy'),
                  name: "issueStrategy",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IssueStrategy, {
                      "device-id": _ctx.terminalInfo.device_id
                    }, null, 8, ["device-id"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]))
}